export {
	getFontSize,
	getFontSizeClass,
	getFontSizeObjectByValue,
} from './utils';
export { default as FontSizePicker } from './font-size-picker';
export { default as withFontSizes } from './with-font-sizes';
